import { requestHelpers } from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_LOCATIONS: "SET_LOCATIONS",
    GENERAL_LOCATION_REQUEST: "GENERAL_LOCATION_REQUEST",
    GENERAL_LOCATION_SUCCESS: "GENERAL_LOCATION_SUCCESS",
    GENERAL_LOCATION_ERROR: "GENERAL_LOCATION_ERROR",
}

export const setLocations = ( profile ) => {
    const primary_location = profile.locations.find( location => location.primary_location === 1);
    return {
        type: actions.SET_LOCATIONS,
        personId: profile.id,
        job_locations: profile.locations,
        profile_location: profile.common_region,
        primary_location,
    }
}


export const locationApiCall = ( personId, payload, type, callbackToHOC ) => {
    const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : type );
    let location_id;

    if ( payload ) {
        location_id = payload.id;
    }

    return ( dispatch ) => {
        dispatch( {
            type: actions.GENERAL_LOCATION_REQUEST,
            isLoading: true,
            isError: false,
        })
        requestHelpers
            .authenticatedPostRequest( `/profiles/${ personId }/location`, { location_id }, requestType )
            .then( ( response ) => {
                callbackToHOC();
                return dispatch( {
                    type: actions.GENERAL_LOCATION_SUCCESS,
                    personId: personId,
                    profile_location: payload,
                })
            })
            .catch( ( error ) => {
                callbackToHOC(error);
            })
      dispatch(updateTodoList(personId, 8));
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/locations.js